module.exports = __webpack_public_path__ + "static/friends_online-a839ce1729b957b3b8b585aaf13d512a.svg";